<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y>
            <template v-slot:activator="{on,attrs}">
              <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="From WayAssign Date"
                  type="text"
                  prepend-icon="event"
                  v-model="queryParams.fromAssignDate"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromAssignDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="To WayAssign Date"
                  type="text"
                  prepend-icon="event"
                  v-model="queryParams.toAssignDate"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toAssignDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="wayAssignStatusList"
                label="Choose WayAssign Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="wayAssignNo"
                label="WayAssign No"
                type="text"
                v-model="queryParams.wayAssignNo"
              ></v-text-field>
            </v-flex>
            
            <v-flex sm4>
              <v-text-field 
                name="wayName" 
                label="Way Name" 
                type="text" 
                v-model="queryParams.wayName"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field 
                name="marketerName" 
                label="Marketer Name" 
                type="text" 
                v-model="queryParams.marketerName"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="wayAssignList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
          <template slot="items" slot-scope="props">
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.username }}</td>
              <td>{{ props.item.wayAssignDateInMilliSeconds | format-ms-date}}</td>
              <td>{{ props.item.wayAssignNo }}</td>
              <td>{{ props.item.way.name }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.completeDateInMilliSeconds | format-ms-date}}</td>
              <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { wayAssignService } from "../../services/way-assign-service";
import { commonService } from "../../services/common-service";

export default {
  name: "WayAssignList",

  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    fromAssignDate: "",
    toAssignDate: "",
    breadcrumbs: [
      {
        text: "Way Management",
        disabled: true
      },
      {
        text: "Way Assign",
        disabled: true
      }
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Marketer Name", align: "left", value: "user.username" },
      { text: "WayAssign Date", value: "wayAssignDate" },
      { text: "WayAssign No", value: "wayAssignNo" },
      { text: "Way Name", value: "way.name" },
      { text: "Description", value: "description" },
      { text: "WayAssign Status", value: "status" },
      { text: "Complete Date", value: "completeDate" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated  By", value: "updatedBy" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0
    },
    wayAssignStatusList: [
      { label: "---All---", value: "" },
      { label: "START", value: "START" },
      { label: "PROGRESS", value: "PROGRESS" },
      { label: "COMPLETED", value: "COMPLETED" }
    ],
    wayAssignList: [],
    totalRows: 0,
    queryParams: {
      fromAssignDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toAssignDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      wayAssignNo: "",
      marketerName: "",
      wayName: "",
      status: "",
      updateUserId: "",
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getWayAssignList();
      },
      deep: true
    }
  },
  created() {
    if (this.user.role.roleName == "SALE_MANAGER") {
      this.queryParams.updateUserId = this.user.id;
    }
    //for deep linking
    if (this.$route.query.fromAssignDate) {
      this.queryParams.fromAssignDate = this.$route.query.fromAssignDate;
    }
    if (this.$route.query.toAssignDate) {
      this.queryParams.toAssignDate = this.$route.query.toAssignDate;
    }
    if (this.$route.query.wayAssignNo) {
      this.queryParams.wayAssignNo = this.$route.query.wayAssignNo;
    }
    if (this.$route.query.marketerName) {
      this.queryParams.marketerName = this.$route.query.marketerName;
    }
    if (this.$route.query.wayName) {
      this.queryParams.wayName = this.$route.query.wayName;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = this.$route.query.updateUserId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getWayAssignList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "way-assigns", query: this.queryParams });
      this.getWayAssignList();
    },
    getWayAssignList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      wayAssignService
        .getWayAssignList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.wayAssignList = res.data.wayAssignList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/way-assign/new");
    },
    onEdit(wayAssign) {
      // go to details page
      this.$router.push("/way-assign/" + wayAssign.id);
    }
  }
};
</script>

